
import { Input } from "@/components/ui/input";
import { Search, SlidersHorizontal } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTranslations } from "@/hooks/useTranslations";

interface WorkoutSearchProps {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
}

export const WorkoutSearch = ({ searchTerm, setSearchTerm }: WorkoutSearchProps) => {
  const { t } = useTranslations("workouts");
  
  return (
    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-4">
      <div className="relative flex-1 w-full sm:max-w-md">
        <div className="relative">
          <Search className="absolute left-3 top-2.5 h-4 w-4 text-muted-foreground dark:text-gray-400" />
          <Input
            placeholder={t("search.placeholder")}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="pl-10 pr-4 py-2 bg-white/90 dark:bg-gray-800/90 backdrop-blur-sm border-slate-200 dark:border-gray-700 rounded-full focus-visible:ring-flame shadow-sm hover:shadow-md transition-shadow text-slate-900 dark:text-gray-100"
          />
          {searchTerm && (
            <button 
              className="absolute right-3 top-2.5 text-slate-400 hover:text-slate-600 dark:text-gray-500 dark:hover:text-gray-300"
              onClick={() => setSearchTerm("")}
            >
              ✕
            </button>
          )}
        </div>
      </div>
      <Button variant="outline" size="sm" className="rounded-full border-slate-200 dark:border-gray-700 bg-white/90 dark:bg-gray-800/90 text-slate-700 dark:text-gray-200 backdrop-blur-sm shadow-sm hover:shadow-md transition-shadow">
        <SlidersHorizontal className="h-4 w-4 mr-2" />
        {t("search.filters")}
      </Button>
    </div>
  );
};
